module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gTvte"))).then(() => parcelRequire('3vTjq'));